import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { useDropzone } from 'react-dropzone';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Fab from '@material-ui/core/Fab';

import StudentContext from '../../context/student-context';
import { submitFeedback } from '../../actions/share-actions'

import NotificationPopover from '../../components/notification/NotificationPopover'
import { Coin } from '../shared/component'
import useStyles from '../../styles/components/drawer/styleDrawer'
import { getIconProfile, getIconDrawer } from '../../utils/helpers/icon/iconHelper';
import { getStudentNumberFromSession, setTime, getRewardPointsSession } from '../../utils/helpers/others/SessionHelper'
import { Claims } from '../../utils/services/cache/ClientCache'

export default function MainMenuDrawer({ noAppBar }) {
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const moment = require('moment');
    const [currentTime, setCurrentTime] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [subject, setSubject] = React.useState('');
    const [content, setContent] = React.useState('');
    const [image, setImage] = React.useState('')
    const [disabled, setDisabled] = React.useState(true);
    const [rejectedImage, setRejectedImage] = React.useState('')
    const [avatar, setAvatar] = React.useState('');
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const {
        getRootProps,
        getInputProps,
        fileRejections
    } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            setImage(acceptedFiles[0]);

        },
        onDropRejected: fileRejections => {
            setRejectedImage(fileRejections[0])
        }
    });
    let welcomeMessage = getStudentNumberFromSession();
    const [isLoading, setIsLoading] = React.useState(false);
    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        type: '',
    });
    const { logout, studentContext } = useContext(StudentContext);

    useEffect(() => {
        initAvatar();
        const interval = setInterval(() => {
            let d = new Date();
            let t = moment(d).format('DD MMMM YYYY HH:mm:ss');
            setCurrentTime(t);
        }, 1000);
        return () => clearInterval(interval);
    }, [])

    useEffect(() => {
        if (subject.length > 1 && content.length > 1)
            setDisabled(false);
        else
            if (!disabled) setDisabled(true);
    }, [subject, content, image])

    const initAvatar = async () => {
        if (!studentContext) return
        switch (studentContext.dinosaur.cluster) {
            case "ICT":
                studentContext.dinosaur.level > 0 ?
                    setAvatar(getIconProfile().img_profile_ict) : setAvatar(getIconProfile().img_profile_ict_egg);
                break;
            case "CEFT":
                studentContext.dinosaur.level > 0 ?
                    setAvatar(getIconProfile().img_profile_ceft) : setAvatar(getIconProfile().img_profile_ceft_egg);
                break;
            case "DSB":
                studentContext.dinosaur.level > 0 ?
                    setAvatar(getIconProfile().img_profile_dsb) : setAvatar(getIconProfile().img_profile_dsb_egg);
                break;
            case "HSS":
                studentContext.dinosaur.level > 0 ?
                    setAvatar(getIconProfile().img_profile_hss) : setAvatar(getIconProfile().img_profile_hss_egg);
                break;
            case "ENG":
                studentContext.dinosaur.level > 0 ?
                    setAvatar(getIconProfile().img_profile_eng) : setAvatar(getIconProfile().img_profile_eng_egg);
                break;
        }
    }

    const logoutWithRedirect = async () => await logout();

    const toggleDrawer = (side, open) => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [side]: open });
    };

    function renderIcon(param) {
        switch (param) {
            case 0:
                return <img src={`${getIconDrawer().ic_menu_home}`} />;
            case 1:
                return <img src={`${getIconDrawer().ic_menu_survey}`} />;
            case 2:
                return <img src={`${getIconDrawer().ic_menu_lc}`} />;
            case 3:
                return <img src={`${getIconDrawer().ic_menu_feature_lc}`} />;
            case 4:
                return <img src={`${getIconDrawer().ic_menu_reward}`} />;
            case 5:
                return <img src={`${getIconDrawer().ic_menu_news}`} />;
            case 6:
                return <img src={`${getIconDrawer().ic_menu_feedback}`} />;
            case 7:
                return <img src={`${getIconDrawer().ic_menu_profile}`} />;
            case 10:
                return <img src={`${getIconDrawer().ic_menu_logout}`} />;
        }
    };

    const itemMenuActive = (text, index) => {
        const cutString = text.substring(0, 4)
        let active = location.pathname.includes(cutString)
        if (index === 2 && location.pathname.includes('Assement')) return active = true
        return active
    }

    const handleClose = async () => {
        setOpen(false);
        setImage('');
        setRejectedImage('');
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        const formData = new FormData()
        formData.append('subject', subject)
        formData.append('content', content)
        formData.append('from', `${Claims.getGivenName()}@sit.singaporetech.edu.sg`)

        if (image) {
            formData.append('attachments', image)
        }
        let response = await submitFeedback(formData)
        if (response > 200) {
            return history.push("/SessionTimeOut")
        }

        if (response.status === "Success") {
            setIsLoading(false);
            inputSnackBarDetails('Your feedback is successfully submitted. Thanks you.', 'success');
        }
        else {
            setIsLoading(false);
            inputSnackBarDetails('Feedback submission Failed. Please email to AdventureLearn@singaporetech.edu.sg', 'error');
        }
        setOpen(false);
        setSubject('')
        setContent('')
        setImage('')
    }

    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });

    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    function renderRoute(param) {
        switch (param) {
            case 0:
                return history.push("/Home");
            case 1:
                return history.push("/Survey");
            case 2:
                {
                    setTime(new Date().getTime())
                    return history.push("/LearningContentCategories");
                }
            case 3:
                return history.push("/Challenge");
            case 4:
                return history.push("/RewardShop");
            case 5:
                return history.push("/News");
            case 6:
                setOpen(true); break;
            case 7:
                return history.push("/Profile");
            default:
                return history.push("/");
        }
    };

    const sideList = side => (
        <div
            className={classes.rootDrawer}
            role="presentation"
            onClick={toggleDrawer(side, false)}
            onKeyDown={toggleDrawer(side, false)}
        >
            <div className={classes.containerAvatarUser}>
                <Grid
                    container
                    direction="column"
                    justify="space-between"
                    alignItems="center">
                    <div className={classes.containerImageUser}>
                        <img src={avatar} />
                    </div>
                </Grid>

            </div>
            <div>
                <List>
                    <ListItem style={{ textAlign: 'center', padding: 0 }}>
                        <ListItemText>
                            <Typography classes={{ root: classes.welcomeMessage }}> {welcomeMessage}</Typography>
                        </ListItemText>
                    </ListItem>
                    <ListItem style={{ textAlign: 'center', padding: 0 }}>
                        <ListItemText>
                            <div className={classes.rootDrawerTime}>
                                {currentTime}
                            </div>
                        </ListItemText>
                    </ListItem>
                </List>
            </div>
            <Divider classes={{ root: classes.rootDivider }} />
            <List disablePadding classes={{ root: classes.containerListMenu }}>
                {['Home', 'Survey', 'Learning Resources', 'Challenges', 'Shop', 'News', 'Feedback', 'Profile'].map((text, index) => (
                    <ListItem
                        className={clsx(itemMenuActive(text, index) && classes.menuActive)}
                        classes={{ root: classes.wrapperListItem }}
                        button
                        key={text}
                        onClick={() => renderRoute(index)}
                    >
                        <ListItemIcon
                            classes={{ root: itemMenuActive(text, index) && classes.iconMenuActive }}
                            className={classes.iconMenu}
                        >
                            {renderIcon(index)}
                        </ListItemIcon>
                        <ListItemText
                            primary={text}
                            classes={{ primary: itemMenuActive(text, index) ? classes.textMenuActive : classes.textMemu }}
                        />
                    </ListItem>
                ))}
            </List>
            <List disablePadding classes={{ root: classes.containerListMenuLogout }}>
                {['Logout'].map((text, index) => (
                    <ListItem
                        button
                        key={text}
                        onClick={() => logoutWithRedirect()}
                        className={clsx(itemMenuActive(text, index) && classes.menuActive)}
                        classes={{ root: classes.wrapperListItem }}
                    >
                        <ListItemIcon
                            classes={{ root: itemMenuActive(text, index) && classes.iconMenuActive }}
                            className={classes.iconMenu}
                        >
                            {renderIcon(10)}
                        </ListItemIcon>
                        <ListItemText
                            primary={text}
                            classes={{ primary: itemMenuActive(text, index) ? classes.textMenuActive : classes.textMemu }}
                        />
                    </ListItem>
                ))}
            </List>
        </div>
    );

    return (
        <>
            {
                noAppBar ?
                    <>
                        <Fab
                            size="medium"
                            color="primary" className="adventurelearn__menuIcon" onClick={toggleDrawer('left', true)}>
                            {
                                <MenuIcon />
                            }
                        </Fab>
                        <div className="adventurelearn__notiIcon">
                            <NotificationPopover />
                        </div>
                    </>
                    :
                    <AppBar position="static">
                        <Toolbar classes={{ root: classes.rootAppbar }}>
                            <IconButton edge='start' classes={{ root: classes.rootMenuIcon }} aria-label="menu" onClick={toggleDrawer('left', true)}>
                                <MenuIcon style={{ color: '#0492C2', fontSize: '38px' }} />
                            </IconButton>
                            <Typography onClick={() => renderRoute(0)} style={{ cursor: 'pointer' }}>
                                <img src="/AdventureLearn_logo_color.png" height={50} />
                            </Typography>
                            <div className={clsx(classes.rootCoin)} >
                                {studentContext &&
                                    <>
                                        <Hidden smDown>
                                            <Coin
                                                coin={studentContext ? studentContext.studentCoins : getRewardPointsSession()}
                                                size="big" />
                                        </Hidden>
                                        <Hidden mdUp>
                                            <Coin
                                                coin={studentContext ? studentContext.studentCoins : getRewardPointsSession()}
                                                size="medium" />
                                        </Hidden>
                                    </>
                                }
                            </div>
                            {
                                //Add sound modifier here.
                            }
                            <div className={classes.rootNotify}>
                                <NotificationPopover />
                            </div>

                        </Toolbar>
                    </AppBar>
            }


            <Drawer open={state.left} onClose={toggleDrawer('left', false)}>
                <Grid container justify="center" alignItems="center" classes={{ root: classes.containerHeaderDrawer }}>
                    <Grid item xs={6}>
                        <div className={classes.containerDrawerImage}>
                            <img src={`${getIconDrawer().logo_drawer}`} />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <div className={classes.toolbar}>
                            <IconButton className={classes.iconCloseContainer} onClick={toggleDrawer('left', false)}>
                                <MenuIcon classes={{ root: classes.iconClose }} />
                            </IconButton>
                        </div>
                    </Grid>

                </Grid>

                {sideList('left')}
            </Drawer>
            <Dialog fullWidth={true}
                maxWidth={false}
                classes={{ root: classes.feedbackRoot, container: classes.feedbackContainer, paper: classes.feedbackPaper }}
                open={open}>
                <DialogTitle id="alert-dialog-title" classes={{ root: classes.rootDialogTitle }}>
                    Submit Feedback
                </DialogTitle>
                <DialogContent classes={{ root: classes.rootDialogContent }}>
                    <div>
                        {
                            isLoading ? <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Please wait for a while...
                                    </DialogContentText>
                            </DialogContent> :
                                <>
                                    <div>
                                        <Typography classes={{ root: classes.dialogContentTitle }}>Feedback Details</Typography>
                                        <TextField
                                            classes={{ root: classes.rootFeedbackSubject }}
                                            InputProps={{ classes: { input: classes.inputTextfield } }}
                                            margin="dense"
                                            placeholder='Feedback Subject'
                                            fullWidth
                                            color="secondary"
                                            variant="outlined"
                                            value={subject}
                                            onChange={event => {
                                                setSubject(event.target.value)
                                            }}
                                        />
                                        <TextField
                                            classes={{ root: classes.rootFeedbackContent }}
                                            InputProps={{ classes: { input: classes.inputTextfield } }}
                                            margin="dense"
                                            placeholder='Feedback details here...'
                                            fullWidth
                                            multiline
                                            rows="8"
                                            color="secondary"
                                            variant="outlined"
                                            value={content}
                                            onChange={event => {
                                                setContent(event.target.value)
                                            }}
                                        />
                                        <div >
                                            <div {...getRootProps({
                                                className: rejectedImage && fileRejections.length !== 0 ? classes.baseStyleReject
                                                    : image ? classes.baseStyleChosen
                                                        : classes.baseStyle
                                            })}>
                                                <input {...getInputProps()} />
                                                <p>{image ? image.path : rejectedImage ? 'Please choose an image file' : 'Drop file here'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <DialogActions classes={{ root: classes.rootDialogAction }}>
                                        <Button onClick={handleClose} variant='outlined' classes={{ root: classes.rootButtonCancel }}>
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} disabled={disabled} classes={{
                                            root: classes.rootButtonOk,
                                            disabled: classes.disabledButton
                                        }}>
                                            Submit
                                        </Button>
                                    </DialogActions>
                                </>
                        }

                    </div>
                </DialogContent>
            </Dialog>
            <Snackbar
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                key={`bottom, center`}
                open={snackBarDetails.open}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}>
                <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>
                    {snackBarDetails.message}
                </Alert>
            </Snackbar>
        </>
    );
}

//<div className={classes.containerProfileUser} onClick={() => history.push("/Profile")}>
//    <div className={classes.wrapperProfileUser}>
//        <img src={getIconDrawer().img_menu_profile} alt="Profile" />
//    </div>
//</div>